import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { CampaignFindOneType } from "@src/resources/campaigns/campaign.service";

const c = initContract();

const index = c.router({
  findOne: {
    method: "GET",
    path: "/campaigns/:id",
    pathParams: z.object({
      id: z.string(),
    }),
    responses: {
      200: c.type<CampaignFindOneType>(),
    },
  },
});

export default index;
